import { Dispatch } from 'redux';
import { BROKER_CONNECT_ACTION_TYPES } from '@constants/actionTypes/brokerConnectTypes';
import API from '@services/API';

import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
interface IPayloadProps {
    available: boolean;
    brokerAvailabilities: Array<{
        day: string;
        fromTime: string;
        toTime: string;
    }>;
    encryptedBrokerId: string | null;
    phoneNumber: string;
    status: string;
}

export const setBrokerConnectData = (payload: IPayloadProps) => ({
    type: BROKER_CONNECT_ACTION_TYPES.SET_BROKERCONNECT_DATA,
    payload,
});

export const setBrokerConnectDataWithoutSave = (payload: IPayloadProps) => ({
    type: BROKER_CONNECT_ACTION_TYPES.SET_BROKERCONNECT_DATA_WITHOUT_SAVE,
    payload,
});

/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const fetchBrokerConnectData = (url: string) => async (dispatch: Dispatch) => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        dispatch(setBrokerConnectData(data));
    } else {
        console.error('there is an error in fetchBrokerConnectData');
    }
};

export const updateBrokerConnectData = (url: string, payload: IPayloadProps) => async (dispatch: Dispatch) => {
    const params = [url, payload, undefined, false];
    const data = await API.postData(params, dispatch, actions);

    if (data) {
        dispatch(setBrokerConnectData(data));
    } else {
        console.error('there is an error in updateBrokerConnectData');
    }
};

export const updateBrokerConnectDataWithoutSave = (payload: IPayloadProps) => async (dispatch: Dispatch) => {
    dispatch(setBrokerConnectDataWithoutSave(payload));
};
